module.exports = __webpack_public_path__ + "img/img003.10eeb566.png";